interface PageSkeletonProps {
  /** executive = dashboard/finanzas hero + strip; domain = header + panel; table = filas */
  variant?: 'executive' | 'domain' | 'table';
  className?: string;
  'data-testid'?: string;
}

function Bone({ className }: { className: string }) {
  return <div className={`page-skeleton__bone animate-pulse ${className}`} aria-hidden />;
}

/**
 * Placeholders de carga alineados al layout de páginas núcleo (misma familia visual).
 */
export function PageSkeleton({
  variant = 'executive',
  className = '',
  'data-testid': testId = 'page-skeleton',
}: PageSkeletonProps) {
  return (
    <div
      className={`page-skeleton page-skeleton--${variant} ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-live="polite"
      data-testid={testId}
    >
      <span className="sr-only">Cargando…</span>
      {variant === 'executive' && (
        <>
          <Bone className="h-20 w-full rounded-2xl" />
          <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-5">
            <Bone className="h-24 rounded-xl" />
            <Bone className="h-24 rounded-xl" />
            <Bone className="h-24 rounded-xl" />
            <Bone className="hidden h-24 rounded-xl sm:block" />
            <Bone className="hidden h-24 rounded-xl xl:block" />
          </div>
          <Bone className="mt-4 h-48 w-full rounded-xl" />
        </>
      )}
      {variant === 'domain' && (
        <>
          <Bone className="h-8 w-2/3 max-w-md rounded-lg" />
          <Bone className="mt-2 h-4 w-1/2 max-w-sm rounded-md" />
          <Bone className="mt-4 h-16 w-full rounded-2xl" />
          <Bone className="mt-4 h-64 w-full rounded-xl" />
        </>
      )}
      {variant === 'table' && (
        <div className="space-y-2">
          <Bone className="h-10 w-full rounded-md" />
          <Bone className="h-10 w-full rounded-md" />
          <Bone className="h-10 w-full rounded-md" />
          <Bone className="h-10 w-full rounded-md" />
        </div>
      )}
    </div>
  );
}
